module.exports = __webpack_public_path__ + "img/45.a25c4c00.jpg";